export default __webpack_public_path__ + "static/media/1.20d2eda6.jpg";